<template>
  <div id="special-issue">
    <div class="ipub-tab-list mar-b-20">
      <span :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleIndex===item?'active':'']"
            v-for="(item,index) in titleTab"
            style="min-width:256px"
            :key="item+index"
            @click="changeTitle(item)">{{index}}</span>
    </div>
    <div>
      <ul class="list-content"
          v-if="dataSource && dataSource.length>0">
        <li class="flex item content-bg mar-b-4"
            style="justify-content: space-between;align-items: center;"
            v-for="(item) in dataSource"
            :key="item.id">
          <div style="width: calc(100% - 180px);">
            <div class="mar-b-10"
                 @click="$router.push('/publishing/special-issue/'+item.id)">
              <p class="ipub-h3 omission-2">{{item.titleText}}</p>
            </div>
            <div style="width:100%"
                 class="flex item-status">
              <span class="ipub-p4"
                    style="margin-right:40px;width:270px">Published Time: {{item.releaseTime ? $moment(item.releaseTime).format('HH : mm DD / MM / YYYY'):'--'}}</span>
              <span class="ipub-p4 mar-r-20">
                {{item.totalViewNum}}
                <ipub-icon class="font-color"
                           type="iconView" />
              </span>
              <span class="ipub-p4 mar-r-20">
                {{item.totalDownloadNum}}
                <ipub-icon class="font-color"
                           type="iconDownload" />
              </span>
              <span class="ipub-p4 mar-r-20">
                {{item.totalCiteNum}}
                <ipub-icon class="font-color"
                           type="iconCitation" />
              </span>
            </div>
          </div>
          <!-- <div style="width:160px"
               class="link-color"
               @click="$router.push('/publishing/special-issue/'+item.id)">
            <ipub-icon type="iconEdit" />
            <a class="ipub-p3 ">
              Edit Special Issues
            </a>
          </div> -->
        </li>
      </ul>
      <template v-else>
        <ipub-empty :text="empty.text"
                    :icon="empty.icon"
                    :title="empty.title" />
      </template>
    </div>
  </div>
</template>
<script>
import main from './main'
export default main
</script>

<style lang="scss" scoped>
@import './main.scss';
</style>
